import { AdminDocumentLibrary } from 'components/routes/Pages/Admin/AdminDocumentLibrary';
import Refund from 'components/routes/Pages/Refund/Refund';
import { Shipments } from 'components/routes/Pages/Shipments/Shipments';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import ModalWrapper from './components/dialogs/modal-wrapper/ModalWrapper';
import { ContentLayout } from './components/layouts/MainFrame/ContentLayout';
import MainFrame from './components/layouts/MainFrame/MainFrame';
import ProfileFrame from './components/layouts/ProfileFrame/ProfileFrame';
import LockGuard from './components/routes/LockGuard';
import { Admin } from './components/routes/Pages/Admin/Admin';
import { AdminAddPartner } from './components/routes/Pages/Admin/AdminAddPartner';
import { AdminCompanyRequests } from './components/routes/Pages/Admin/AdminCompanyRequests';
import { AdminProductsManagement } from './components/routes/Pages/Admin/AdminProductsManagement';
import { AdminUsers } from './components/routes/Pages/Admin/AdminUsers';
import { Login } from './components/routes/Pages/Authentication/Login/Login';
import { LogoutLandingPage } from './components/routes/Pages/Authentication/Logout/LogoutLandingPage';
import { Registration } from './components/routes/Pages/Authentication/Registration/Registration';
import { ForgotPassword } from './components/routes/Pages/Authentication/forgot-password/ForgotPassword';
import { ForgotPasswordLanding } from './components/routes/Pages/Authentication/forgot-password/ForgotPasswordLanding';
import { Cart } from './components/routes/Pages/Cart/Cart';
import { Collections } from './components/routes/Pages/Collections/Collections';
import { CommentTemplates } from './components/routes/Pages/CommentTemplates/CommentTemplates';
import { ControlPagesWrapper } from './components/routes/Pages/ControlPagesWrapper';
import { DocumentLibrary } from './components/routes/Pages/DocumentLibrary/DocumentLibrary';
import Error404 from './components/routes/Pages/Error404/Error404';
import { Invoices } from './components/routes/Pages/Invoices/Invoices';
import { LiveOrders } from './components/routes/Pages/LiveOrders/LiveOrders';
import { MyQuotationDetails } from './components/routes/Pages/MyQuotationDetails/MyQuotationDetails';
import { MyQuotations } from './components/routes/Pages/MyQuotations/MyQuotations';
import PDFPreview from './components/routes/Pages/PDFPreview/PDFPreview';
import { PageWrapper } from './components/routes/Pages/PageWrapper';
import { ProductPage } from './components/routes/Pages/ProductPage/ProductPage';
import { Profile } from './components/routes/Pages/Profile/Profile';
import { QuotationDetails } from './components/routes/Pages/QuotationDetails/QuotationDetails';
import { QuotationEditor } from './components/routes/Pages/QuotationEditor/QuotationEditor';
import { Quotations } from './components/routes/Pages/Quotations/Quotations';
import { SearchPage } from './components/routes/Pages/SearchPage/SearchPage';
import RouteGuard from './components/routes/RouteGuard';
import { GlobalErrorConfiguration } from './hooks/globalErrorUtils';
import { store } from './redux/store';
import { SnackbarContent } from './utils/SnackbarUtils';
import { BootstrapHandler } from './utils/bootstrapHandler';
import {
    SIDEBAR_ADMIN_NAVIGATION,
    SIDEBAR_PROFILE_NAVIGATION,
} from './utils/constans/SidebarMenu';
import './utils/i18n';

const StyledApp = styled.div`
    background-color: white !important;
    //color: black !important;
`;

export const queryClient = new QueryClient();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <StyledApp>
                <BootstrapHandler />
                <Provider store={store}>
                    <GlobalErrorConfiguration />
                    <ModalWrapper />
                    <SnackbarContent />
                    <Routes>
                        <Route path={'login'} element={<Login />} />
                        <Route
                            path={'registration'}
                            element={<Registration />}
                        />
                        <Route
                            path={'forgot-password'}
                            element={<ForgotPassword />}
                        />
                        <Route
                            path={'logout'}
                            element={<LogoutLandingPage />}
                        />
                        <Route
                            path={'password-reset/:token/'}
                            element={<ForgotPasswordLanding />}
                        />
                        <Route element={<RouteGuard />}>
                            <Route path={'/'} element={<ProfileFrame />}>
                                <Route
                                    index
                                    element={<Navigate to={'profile'} />}
                                />
                                <Route
                                    path={'profile'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Profile />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'invoices'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Invoices />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'shipments'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Shipments />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'live-orders'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <LiveOrders />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                {/*<Route*/}
                                {/*    path={'cart'}*/}
                                {/*    element={*/}
                                {/*        <PageWrapper>*/}
                                {/*            <ControlPagesWrapper*/}
                                {/*                sidebarItems={*/}
                                {/*                    SIDEBAR_PROFILE_NAVIGATION*/}
                                {/*                }*/}
                                {/*            >*/}
                                {/*                <Cart />*/}
                                {/*            </ControlPagesWrapper>*/}
                                {/*        </PageWrapper>*/}
                                {/*    }*/}
                                {/*/>*/}
                                <Route
                                    path={'document-library'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <DocumentLibrary />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'quotations'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Quotations />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'my-quotations'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <MyQuotations />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'my-quotations/:quoteId'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <MyQuotationDetails />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'quotation'}
                                    element={<Navigate to={'/quotations'} />}
                                />
                                <Route
                                    path={'quotation/edit/:quoteId'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <QuotationEditor />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'quotation/:quoteId'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <QuotationDetails />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'comment-templates'}
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <CommentTemplates />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path="refund"
                                    element={
                                        <PageWrapper>
                                            <ControlPagesWrapper
                                                sidebarItems={
                                                    SIDEBAR_PROFILE_NAVIGATION
                                                }
                                            >
                                                <Refund />
                                            </ControlPagesWrapper>
                                        </PageWrapper>
                                    }
                                />
                            </Route>
                            <Route element={<MainFrame />}>
                                <Route
                                    path={'cart'}
                                    element={
                                        <PageWrapper>
                                            <ContentLayout>
                                                <Cart />
                                            </ContentLayout>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'search'}
                                    element={
                                        <PageWrapper>
                                            <ContentLayout>
                                                <SearchPage />
                                            </ContentLayout>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'collections/:handle'}
                                    element={
                                        <PageWrapper>
                                            <ContentLayout>
                                                <Collections />
                                            </ContentLayout>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={
                                        'collections/:handle/products/:productHandle'
                                    }
                                    element={
                                        <PageWrapper>
                                            <ContentLayout>
                                                <ProductPage />
                                            </ContentLayout>
                                        </PageWrapper>
                                    }
                                />
                                <Route
                                    path={'products/:productHandle'}
                                    element={
                                        <PageWrapper>
                                            <ContentLayout>
                                                <ProductPage />
                                            </ContentLayout>
                                        </PageWrapper>
                                    }
                                />
                            </Route>
                            <Route element={<LockGuard />}>
                                <Route path={'/'} element={<ProfileFrame />}>
                                    <Route
                                        path={'admin'}
                                        element={
                                            <PageWrapper>
                                                <ControlPagesWrapper
                                                    sidebarItems={
                                                        SIDEBAR_ADMIN_NAVIGATION
                                                    }
                                                >
                                                    <Admin />
                                                </ControlPagesWrapper>
                                            </PageWrapper>
                                        }
                                    >
                                        <Route
                                            path={'add-partner'}
                                            element={<AdminAddPartner />}
                                        />
                                        <Route
                                            path={'users'}
                                            element={<AdminUsers />}
                                        />
                                        <Route
                                            path={'company-requests'}
                                            element={<AdminCompanyRequests />}
                                        />
                                        <Route
                                            path={'products-management'}
                                            element={
                                                <AdminProductsManagement />
                                            }
                                        />
                                        <Route
                                            path={'document-library'}
                                            element={<AdminDocumentLibrary />}
                                        />
                                    </Route>
                                </Route>
                                <Route
                                    path={'PDFPreview'}
                                    element={<PDFPreview />}
                                />
                            </Route>
                            <Route path={'*'} element={<Error404 />} />
                        </Route>
                    </Routes>
                </Provider>
            </StyledApp>
        </QueryClientProvider>
    );
}

export default App;
